<template>
    <main-content v-if="$can('manage-collective-gateways', 'ipg-gateway')" with_go_back_bar>
        <collective-gateway-filter :action="filterAction"></collective-gateway-filter>
        <kt-datatable  v-bind="datatableProps" ref="datatable"></kt-datatable>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import columns from "./datatable/active_gateways_columns";
import actionsColumn from "./datatable/active-gateways-actions-column";
import {StarShopApiUrl} from '@/common/api.service'
import { AuthorizationHeader } from '@/common/jwt.service'
import CollectiveGatewayFilter from "@/views/gateway/components/collective-gateway-filter.vue";

export default {
    components: {
        CollectiveGatewayFilter,
        'main-content': mainContent,
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    },
    data() {
        return {
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "gateway_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: StarShopApiUrl.path('collective/active-gates'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: this.query,
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
}
</script>

<style>

</style>